import {helpers} from 'lib.front';

export const SCRN_GENERAR_LICENCIA = new helpers.Screen('Generar Licencia', '/generarLicencia');
export const SCRN_CALLBACK = new helpers.Screen('Callback', '/callback');
export const SCRN_PRUEBA = new helpers.Screen('Prueba', '/prueba');
export const SCRN_SUSCRIPCION_NUBE = new helpers.Screen('Suscripción Nube', '/suscripcionNube');
export const SCRN_MODIFICAR_LICENCIA = new helpers.Screen(
   'Modificar Licencia',
   '/modificarLicencia'
);
export const SCRN_ADMINISTRAR_LICENCIA = new helpers.Screen(
   'Administrar Licencia',
   '/administrarLicencia'
);
export const SCRN_LISTAR_LLAVES = new helpers.Screen('Listado de Licencias', '/listarLlaves');
export const SCRN_ENVIAR_MAIL = new helpers.Screen('Enviar E-mail', '/enviarMail');
export const SCRN_HISTORIAL_LICENCIA = new helpers.Screen(
   'Historial Licencia',
   '/historialLicencia'
);
export const SCRN_PRODUCTO = new helpers.Screen('Producto', '/producto');
export const SCRN_VERSION = new helpers.Screen('Versión', '/version');
export const SCRN_PRESENTACION = new helpers.Screen('Presentación', '/presentacion');
export const SCRN_PRODUCTO_DETALLE = new helpers.Screen('Gestionar Productos', '/productoDetalle');
export const SCRN_NOT_FOUND = new helpers.Screen('No Encontrado', '/notFound');
export const SCRN_LOG_IN = new helpers.Screen('Log In', '/log-in');
export const SCRN_DS_LOG_IN = new helpers.Screen('DS Log In', '/ds-login');
export const SCRN_DS_SIGN_UP = new helpers.Screen('DS Sign Up', '/ds-signup');
export const SCRN_PATCH_NOTES = new helpers.Screen('', '/patch-notes');
export const SCRN_ACTUALIZACION_MASIVA_LICENCIAS = new helpers.Screen(
   'Actualización Masiva',
   '/actualizacionMasivaLicencias'
);
export const SCRN_GESTIONAR_TIPO_CAMBIO = new helpers.Screen(
   'Gestionar Tipo de Cambio',
   '/gestionarTipoCambio'
);
export const SCRN_GESTIONAR_APPS_DBS = new helpers.Screen(
   'Gestionar Bases de Datos de Aplicaciones',
   '/gestion/apps-dbs'
);
export const SCRN_ADMINISTRAR_CLIENTES_DSCLOUD = new helpers.Screen(
   'Administrar Clientes',
   '/administrarClientesDsCloud'
);
export const SCRN_BUSCADOR_UUID = new helpers.Screen('Buscador GUID', '/buscadorGuid');
export const SCRN_DASHBOARD = new helpers.Screen('Dashboard', '/dashboard');
export const SCRN_ABONOS_PASARELA = new helpers.Screen('Abonos Pasarela de Pagos', '/abonosPasarela');
export const SCRN_REPORTE_CONCILIADOR = new helpers.Screen('Reporte Conciliador', '/reporteConciliador');
